import React from 'react';
import clsx from 'clsx';

import styles from './MembershipCard.module.css';

import logo from '../pages/images/logo-horiz.svg';
import dollar from '../pages/images/dollar.svg';

import { Membership } from '../lib/functionality';

import Skeleton from 'react-loading-skeleton';

interface MembershipCardProps {
  membership?: Membership;
}

const MembershipCard = ({ membership }: MembershipCardProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.cardNumber}>
        {!membership ? (
          <Skeleton />
        ) : membership.memberid ? (
          membership.memberid
        ) : (
          '-----'
        )}
      </div>
      <div className={styles.memberName}>
        {membership ? (
          `${membership.firstname} ${membership.lastname}`
        ) : (
          <Skeleton />
        )}
      </div>
      <div
        className={clsx(styles.statusPill, {
          [styles.unpaid]: !membership?.paid,
        })}>
        {membership ? (
          <>
            <img src={dollar} alt="Payment Status" />
            {membership.paid ? 'PAID' : 'UNPAID'}
          </>
        ) : (
          <Skeleton />
        )}
      </div>
      <img src={logo} alt="Seven Monks Taproom" className={styles.logo} />
    </div>
  );
};

export default MembershipCard;
